import { site } from "@/config/site";

export const CONSENT_TEXT =
  "By submitting this form, you agree that AutomationTK may contact you about your enquiry. Do not submit passwords, secrets, API keys or highly sensitive information through this form.";

type SheetTab =
  | "WorkflowDiagnosis"
  | "WebinarRegistrations"
  | "ContactMessages"
  | "SupportRequests"
  | "CRM_Log";

export type LeadPayload = {
  tab: SheetTab;
  data: Record<string, string | undefined>;
  notifyEmail?: string;
};

/**
 * Stub for Google Workspace integration. When googleSheetsIntegrationEnabled is true
 * and a server endpoint is wired, this will POST to it. Until then it resolves cleanly
 * so the public UI never shows broken behaviour.
 */
export async function submitLead(payload: LeadPayload): Promise<{ ok: true }> {
  if (site.googleSheetsIntegrationEnabled) {
    try {
      await fetch("/api/lead", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...payload, consent_text: CONSENT_TEXT }),
      });
    } catch {
      // Silent — still resolve so the user gets the thank-you experience.
    }
  } else {
    // Simulate a small network delay for credible UX.
    await new Promise((r) => setTimeout(r, 450));
  }
  return { ok: true };
}

export function track(event: string, metadata?: Record<string, unknown>) {
  if (!site.analyticsEnabled) return;
  // Hook for analytics provider when enabled. No-op when disabled.
  if (typeof window !== "undefined" && (window as any).dataLayer) {
    (window as any).dataLayer.push({ event, ...metadata });
  }
}
